import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../../styles/detailStyles.css';
import PCLayout from '../../PCLayout';

const ExperienceDetailPage = ({ isDarkMode, toggleTheme }) => {
    const navigate = useNavigate();
    const [experiences, setExperiences] = useState([]);
    const [selectedExperience, setSelectedExperience] = useState(null);

    useEffect(() => {
        fetch('/data/experience.json')
            .then(response => response.json())
            .then(data => setExperiences(data))
            .catch(error => console.error('Error fetching experience data:', error));
    }, []);

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                closeModal();
            }
        };

        if (selectedExperience) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [selectedExperience]);

    const openModal = (exp) => {
        setSelectedExperience(exp);
    };

    const closeModal = () => {
        setSelectedExperience(null);
    };

    const handleBack = () => {
        navigate('/prof', { state: { targetSection: 'experience' } });
    };

    return (
        <PCLayout
            isDarkMode={isDarkMode}
            toggleTheme={toggleTheme}
            activePage="experience"
        >

            <div className="detailPageContent">
                <div className="inlineBackButtonContainer">
                    <button onClick={handleBack} className="inlineBackButton">
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                </div>
                <div className="cardGrid">
                    {experiences.map((exp) => (
                        <div className="card experienceCard" key={exp.id} onClick={() => openModal(exp)}>
                            <h3 className="cardTitle">{exp.title}</h3>
                            <span className="cardDate">{exp.period}</span>

                            <div className="cardLocation">
                                <i className="fa-solid fa-building"></i> {exp.location}
                            </div>

                            <p className="cardDescription">
                                {exp.description}
                            </p>

                            <div className="cardTags">
                                {exp.technologies?.map((tech, index) => (
                                    <span className="cardTag" key={index}>{tech}</span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {selectedExperience && (
                <div className="modalOverlay" onClick={closeModal}>
                    <div className="detailModalContent" onClick={(e) => e.stopPropagation()}>
                        <button className="detailModalClose" onClick={closeModal}>&times;</button>
                        <div className="detailModalHeader">
                            <h2 className="detailModalTitle">{selectedExperience.title}</h2>
                            <span className="detailModalDate">{selectedExperience.period}</span>
                            <div className="cardLocation" style={{ marginTop: '0.5rem' }}>
                                <i className="fa-solid fa-building"></i> {selectedExperience.location}
                            </div>
                        </div>
                        <div className="detailModalBody">
                            <p className="detailModalText" style={{ marginBottom: '1.5rem' }}>
                                {selectedExperience.description}
                            </p>
                            {selectedExperience.bullets && selectedExperience.bullets.length > 0 && (
                                <div className="modalBulletsSection">
                                    <h3>Key Responsibilities & Achievements</h3>
                                    <ul className="modalBullets">
                                        {selectedExperience.bullets.map((bullet, index) => (
                                            <li key={index}>
                                                {bullet}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <div className="cardTags" style={{ marginTop: '1.5rem' }}>
                                {selectedExperience.technologies?.map((tech, index) => (
                                    <span className="cardTag" key={index}>{tech}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </PCLayout>
    );
};

export default ExperienceDetailPage;